import { DefinitionStat } from '@/components/common/definitionStat'
import { cn } from '@/utils/cn'
import type { FixedTermMarket } from '@/utils/internalAppSdk'
import { getValueColor } from '@/utils/styles/getValueColor'
import { SECOND_IN_MILLISECONDS } from '@vaultsfyi/common/constants'
import { formatDate, formatDecimalToPercentage, formatUSD } from '@vaultsfyi/common/utils'

interface Props {
  market: FixedTermMarket
}

export const FixedTermMarketProjectedYield = ({ market }: Props) => {
  const maturityDate = formatDate({
    timestamp: market.expiry * SECOND_IN_MILLISECONDS,
    options: { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' },
  })

  return (
    <section className="flex flex-col gap-4">
      <div className="flex flex-col gap-0.5">
        <h2 className="font-medium text-heading-foreground text-lg">Projected yield</h2>
        <p className="text-caption-foreground text-xs">The displayed APY assumes the PT is held until maturity.</p>
      </div>
      <dl className="flex flex-wrap gap-x-8 gap-y-3 sm:grid sm:grid-cols-[auto_auto_1fr]">
        <DefinitionStat
          label="Current TVL"
          value={formatUSD(market.tvl.usd)}
          className="min-w-fit flex-1 gap-0.5 sm:flex-none"
          labelClassName="font-normal"
          valueClassName="truncate tabular-nums"
        />
        <DefinitionStat
          label="Fixed APY"
          value={formatDecimalToPercentage(market.fixedApy)}
          className="min-w-fit flex-1 gap-0.5 sm:flex-none"
          labelClassName="font-normal"
          valueClassName={cn('truncate tabular-nums', getValueColor(market.fixedApy))}
        />
        <DefinitionStat
          label="Maturity date"
          value={maturityDate}
          className="min-w-fit flex-1 gap-0.5 sm:items-end sm:justify-self-end sm:text-right"
          labelClassName="font-normal"
          valueClassName="truncate tabular-nums"
        />
      </dl>
    </section>
  )
}
